import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import TransInternationalContainer from "./TransInternationalContainer";
import { useGetMoneySourceQuery } from "@/services/bankAPI";
import { getDefaultTransferSource } from "@/helpers/moneySource";

const TransInternationalWrapper: React.FC = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const { data: moneySourceData } = useGetMoneySourceQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const sources = useMemo(() => {
    return moneySourceData?.body?.sources || [];
  }, [moneySourceData]);
  const [sourceLinkId, setSourceLinkId] = useState<number>(
    getDefaultTransferSource(sources)?.id ?? 0,
  );

  // sources về sau (API async) nên init useState luôn rỗng -> set TK nguồn
  // mặc định ngay khi danh sách sẵn sàng để Bước 1/Bước 4 hiển thị đúng.
  useEffect(() => {
    if (!sourceLinkId && sources.length > 0) {
      const defaultId = getDefaultTransferSource(sources)?.id;
      if (defaultId) setSourceLinkId(defaultId);
    }
  }, [sources, sourceLinkId]);

  const handleChangeSourceLink = async (request: number) => {
    if (!request) {
      //   form.setErrors({
      //     sourceLinkId: "Chua chon ngan hang",
      //   });
      return;
    }
    setSourceLinkId(request);
  };

  const handleSubmitStepOne = () => {
    setStep(2);
  };
  const handleSubmitStepTwo = () => {
    setStep(3);
  };
  const handleSubmitStepThree = () => {
    setStep(4);
  };
  const handleSubmitStepFour = () => {
    setStep(5);
  };
  return (
    <TransInternationalContainer
      step={step}
      sourceLinkId={sourceLinkId}
      sources={sources}
      onChangeSourceLink={handleChangeSourceLink}
      onSubmitStepOne={handleSubmitStepOne}
      onSubmitStepTwo={handleSubmitStepTwo}
      onSubmitStepThree={handleSubmitStepThree}
      onSubmitStepFour={handleSubmitStepFour}
      onBackStepOne={() => setStep(1)}
      onBackStepTwo={() => setStep(2)}
      onBackStepThree={() => setStep(3)}
      onGoHome={() => navigate("/")}
      onCreateNew={() => setStep(1)}
    />
  );
};

export default TransInternationalWrapper;
